<template>
  <div class="page">
    <van-nav-bar title="设备列表" fixed></van-nav-bar>

    <van-pull-refresh class="refresh" v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.deviceId">
          <van-cell :label="'状态更新时间：' + item.connectionUpdateTime" is-link center @click="clickCell(item)">
            <template #title>
              <div style="display: flex;align-items: center">
                <span style="margin-right: 10px">{{ item.deviceName }}</span>
                <van-tag v-if="item.connectionStatus === '在线'" type="success">在线</van-tag>
                <van-tag v-else>离线</van-tag>
                <!--              <van-tag>{{item.connectionStatus }}</van-tag>-->
              </div>
            </template>
          </van-cell>
          <template #right>
            <van-button square type="info" text="操作" style="height: 100%" @click="showAction = true; actionDeviceId = item.deviceId"/>
<!--            <van-icon name="ellipsis" />-->
          </template>
        </van-swipe-cell>


        <!--        <van-cell v-for="item in list" :key="item.deviceId" :title="item.name" :label="'今日单量：' + item.todayOrderCount" />-->
      </van-list>
    </van-pull-refresh>

    <van-action-sheet
      v-model="showAction"
      :actions="actions"
      cancel-text="取消"
      @select="onSelectAction"
      close-on-click-action
    />
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [],
      showAdd: false,
      form: {deviceId: '', name: '', longitude: undefined, latitude: undefined},
      actionDeviceId: undefined,
      showAction: false,
      actions: [{ name: '重启', color: '#f00' }, { name: '重连', color: '#5aee0a', subname: '将离线10秒再重新连接'}, {name: '卡信息'}]
    }
  },
  methods: {
    onSelectAction(action, index) {
      let content = {}
      switch (index) {
        case 0:
          content['action'] = 'reboot'
          this.pushAction(content)
          break
        case 1:
          content['action'] = 'reConnect'
          content['data'] = {'delay': 10}
          this.pushAction(content)
          break
        case 2:
          this.$http.get('cabinet/cardInfo?deviceId=' + this.actionDeviceId).then(res => {
            if (res.code === 200) {
              console.log(res.data)
              let info = res.data
              this.$dialog({
                messageAlign: 'left',
                message: `卡\t号：${info.cardNo}\n运营商：${info.operatortypecode}\n流\t量：${info.flow}MB`
              })
            } else {
              this.$toast.fail(res.msg)
            }
          })
          break
      }
    },
    pushAction(content) {
      this.$dialog({message: '确认操作？', showCancelButton: true}).then(() => {
        this.$http.post('cabinet/mqtt/message', {topic: `/userAction/${this.actionDeviceId}`, content: JSON.stringify(content)}).then(res => {
          if (res.code === 200) {
            this.$toast.success('已推送')
          } else {
            this.$toast.fail(res.msg)
          }
        }).catch(err => {
          this.$toast.fail(err.toLocaleString())
        })
      }).catch(() => {})
    },

    onRefresh() {
      this.onLoad()
    },
    onLoad() {
      this.loading = true
      this.$http.get('cabinet').then(res => {
        this.loading = false
        this.finished = true
        this.refreshing = false
        if (res.code === 200) {
          res.data.sort((a, b) => {
            if (a.connectionStatus === '在线' && b.connectionStatus === '在线') return 0
            if (a.connectionStatus === '离线' && b.connectionStatus === '在线') return 1
            if (a.connectionStatus === '在线' && b.connectionStatus === '离线') return -1
          })
          this.list = res.data
        } else {
          if (res.code === 403) {
            this.$toast.fail('登录信息过期，请重新登录')
            this.$bus.$emit('login')
          }
        }
      }).catch(() => {
        this.loading = false
        this.refreshing = false
        this.finished = true
      })
    },

    clickCell(cabinet) {
      this.$router.push({
        path: '/cabinetCell',
        query: {cabinetId: cabinet.deviceId, belongEleMeSystem: cabinet.belongEleMeSystem, name: cabinet.deviceName}
      })
    }
  }
}
</script>

<style scoped>
/deep/ .van-list__finished-text {
  /*margin-bottom: 100px;*/
  padding-bottom: 100%;
  background-color: whitesmoke;
}
.refresh {
  margin-top: 46px;
  /*padding-bottom: 100px;*/
}
</style>
